import { Popup } from "components/UI/Popup";
import { CopyTextControl } from "components/controls";

import "./EmbedDialog.scss";
import { useCallback } from "react";
import { metrics } from "../../utils/metrics";

export const EmbedDialog = (props: {
  fixedEmbedCode: string;
  responsiveEmbedCode: string;
  onClose: () => void;
  isOpen: boolean;
}): JSX.Element => {
  const { fixedEmbedCode, responsiveEmbedCode, onClose, isOpen } = props;

  const handleClickFixedEmbed = useCallback(async () => {
    await metrics.sendShareEmbedFixed();
  }, []);

  const handleClickResponsiveEmbed = useCallback(async () => {
    await metrics.sendShareEmbedResponsive();
  }, []);

  return (
    <Popup
      onClose={onClose}
      isOpen={isOpen}
      popupClass="EmbedDialog"
      title="Embed"
    >
      <>
        <div className="group">
          <label>Fixed frame:</label>
          <CopyTextControl value={fixedEmbedCode} onClick={handleClickFixedEmbed}/>
        </div>

        <div className="group">
          <label>Responsive frame:</label>
          <CopyTextControl value={responsiveEmbedCode} onClick={handleClickResponsiveEmbed}/>
        </div>
      </>
    </Popup>
  );
};
